import type { components } from '@pba/types-openapi-client';
import { type UserDetail, createUserDetail } from './detail';

export type Profile = UserDetail;

export const createProfile = (data: components['schemas']['UserDetail']): Profile => ({
  ...createUserDetail(data),
});
